import { useGlobalStore } from "@/stores/GlobalStore";
import { ErrorLocationType } from "@/utilities/enums/Enums";

export default function hideError ({next}:any){
    const globalStore = useGlobalStore();

    if (globalStore.error.location !== ErrorLocationType.none) globalStore.error.location = ErrorLocationType.none;

    return next();
}